export default __webpack_public_path__ + "static/media/vrf5.8b67aef2.jpg";